import i18next from 'i18next';

i18next.addResources('es', 'MevStepsTable', {
  date: 'Fecha',
  description: 'Descripción',
  signed: 'Firmado',
  searchPlaceholder: 'Buscar por fecha o descripción...',
  empty: 'No se encontraron pasos procesales',
  detailModalTitle: 'Detalle del paso procesal',
  generalInfoTitle: 'Información general',
  sourceLabel: 'Fuente',
  fojasLabel: 'Fojas',
  positionNumberLabel: 'N° de posición',
  wasNotifiedLabel: 'Notificado',
  signedLabel: 'Firmado',
  failedLabel: 'Este paso procesal presentó un error al procesarse',
  yes: 'Sí',
  no: 'No',
  generalReferencesTitle: 'Información adicional',
  commentsTitle: 'Comentarios',
  attachmentsTitle: 'Archivos adjuntos',
  documentLinkLabel: 'Ver documento'
});
